"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainFunctions = chainFunctions;
function chainFunctions(funcs) {
    if (funcs.length === 1) {
        return funcs[0];
    }
    return funcs.reduce((a, b) => (...args) => a(b(...args)));
}
